module.exports = "<clr-alert [clrAlertType]=\"globalMessage.type\" [clrAlertAppLevel]=\"isAppLevel\" [(clrAlertClosed)]=\"!globalMessageOpened\" (clrAlertClosedChange)=\"onClose()\">\n    <div class=\"alert-item\">\n        <span class=\"alert-text\">\n          {{message}}\n        </span>\n        <div class=\"alert-actions\" *ngIf=\"needAuth\">\n            <button class=\"btn alert-action\" (click)=\"signIn()\">{{ 'BUTTON.LOG_IN' | translate }}</button>\n        </div>\n    </div>\n</clr-alert>"


//////////////////
// WEBPACK FOOTER
// ./src/app/global-message/message.component.html
// module id = 863
// module chunks = 0